package navigation.home.service.addextraservice

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.service.domain.repository.ServiceRepository
import com.essntl.features.service.domain.use_case.ExtraCategoryServiceUseCase
import com.essntl.features.service.ui.addextraservice.AddExtraServiceEvent
import com.essntl.features.service.ui.addextraservice.AddExtraServiceFormValidation
import com.essntl.features.service.ui.addextraservice.AddExtraServiceState
import com.essntl.features.service.ui.addextraservice.AddExtraServiceViewModel

class AddExtraServiceScreenModel(
    serviceRepository: ServiceRepository,
    extraCategoryServiceUseCase: ExtraCategoryServiceUseCase,
    loadingManager: LoadingManager,
) : StateScreenModel<AddExtraServiceState>(AddExtraServiceState()) {
    val validation = AddExtraServiceFormValidation()

    val vm = AddExtraServiceViewModel(
        serviceRepository = serviceRepository,
        extraCategoryServiceUseCase = extraCategoryServiceUseCase,
        loadingManager = loadingManager,
        scope = screenModelScope,
        state = mutableState,
    )

    fun onEvent(event: AddExtraServiceEvent) = vm.onEvent(event)
}